<section
  class="mb-6 rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white p-5">

  <div class="grid grid-cols-12 gap-4">

    <div class="col-span-12 lg:col-span-7">
      <p
        class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
        Central TikTok Connection
      </p>

      <h3 class="mt-1 text-xl font-bold text-gray-900">
        Connect TikTok
      </h3>

      <p class="mt-2 text-sm leading-6 text-gray-600">
        Connect a TikTok account.
      </p>
    </div>

    <div class="col-span-12 lg:col-span-5">
      <label
        for="publio-tiktok-site"
        class="mb-2 block text-sm font-semibold text-gray-700">
        Publio Site
      </label>

      <select
        id="publio-tiktok-site"
        [ngModel]="selectedSiteId"
        (ngModelChange)="onSiteChange($event)"
        [disabled]="
          loadingConnect ||
          loadingStatus
        "
        class="h-12 w-full rounded-xl border border-gray-300 bg-white px-3 text-sm text-gray-800 outline-none focus:border-gray-500 focus:ring-2 focus:ring-gray-200">

        <option [ngValue]="null">
          Select a Site
        </option>

        <option
          *ngFor="let site of sites"
          [ngValue]="site.id">
          {{ site.domain }}
        </option>
      </select>

      <button
        type="button"
        (click)="connectionStatus?.connected ? disconnect() : connect()"
        [disabled]="
          !selectedSiteId ||
          loadingConnect ||
          loadingStatus
        "
        [ngClass]="{
          'primary-btn': !connectionStatus?.connected,
          '!bg-red-500': connectionStatus?.connected,
          '!text-white': connectionStatus?.connected,
          'hover:!bg-red-600': connectionStatus?.connected
        }"
        class="mt-3 h-12 w-full rounded-xl px-5 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50">

        {{
          loadingConnect
            ? "Opening TikTok..."
            : connectionStatus?.connected
              ? "Disconnect TikTok"
              : "Connect with TikTok"
        }}
      </button>
    </div>

    <div
      *ngIf="loadingStatus"
      class="col-span-12 rounded-xl border border-gray-300 bg-gray-50 px-4 py-3 text-sm text-gray-700">
      Loading TikTok connection status...
    </div>

    <div
      *ngIf="connectionStatus && !loadingStatus"
      class="col-span-12 rounded-xl border border-gray-300 bg-white p-4">

      <div class="grid grid-cols-12 gap-4">

        <div class="col-span-12 md:col-span-6">
          <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
            Status
          </p>

          <p
            class="mt-1 text-sm font-bold"
            [class.text-green-700]="connectionStatus.connected"
            [class.text-gray-700]="!connectionStatus.connected">
            {{
              connectionStatus.connected
                ? "Connected"
                : "Not connected"
            }}
          </p>
        </div>

        <div class="col-span-12 md:col-span-6">
          <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
            Instructions
          </p>

          <p class="mt-1 text-sm font-medium text-gray-800">
            After connecting, you can create and view TikTok posts from the TikTok dashboard.
          </p>
        </div>

      </div>
    </div>

    <div
      *ngIf="errorMessage"
      class="col-span-12 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
      {{ errorMessage }}
    </div>

    <div
      *ngIf="connected"
      class="col-span-12 rounded-xl border border-green-200 bg-green-50 px-4 py-3 text-sm font-medium text-green-700">
      TikTok connection saved successfully.
    </div>

  </div>
</section>